import { AnaColumn } from '../../services/forms-template.service';
import { Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, HostListener, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgxSpinnerService } from 'ngx-spinner';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';

import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';

import { NicaFormComponent } from '../nica-form/nica-form.component';
import { DomSanitizer } from '@angular/platform-browser';

import { NicaMaster } from '../nica-master-component/nica-master.component';


@Component({
  selector: 'app-generate-form',
  templateUrl: './generate-form.component.html',
  styleUrls: ['./generate-form.component.css', '../../views/ana-soggetto/ana-soggetto.component.css']
})
export class GenerateFormComponent extends NicaMaster implements OnInit {
  @ViewChild('formGeneretorAnagrafica', { static: false }) formGeneretorAnagrafica: NicaFormComponent;
  @ViewChild('previewForm', { static: false, read: ViewContainerRef }) previewForm: ViewContainerRef;


  configuration: any[] = [];
  buttonCustom: any[] = [];
  formItems: AnaColumn[] = [];
  popupVisibleForm: boolean;
  datas: any[] = []
  myJson: any;
  componentRef: any;
  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    private sanitizer: DomSanitizer,

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService

    );


  }

  ngOnInit() {
    this.activatedroute.queryParams.subscribe((params) => {
      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName

      this.setGlobalVariableFromParams(params);
      if (this.template == 'form' && this.SubjectCall == 'generaConfigurazione') {
        if (typeof this.filterID['dataGroups'] != 'undefined') {
          //this.formSoggetto.formRefreshInputData('data',this.filterID['dataGroups'])

          this.rowData = this.filterID;
          this.initializzed(this.filterID);
        } else {
          if (this.id) {


            this.anagraficaService.getValue(this.apiset, this.id, '').then(res => {

              if (res['json']) {
                this.initializzed(res['json']);
                this.myJson = res['json']
              }
            })
            
          }
        }


      } else {
        this.initializzed(this.filterID['dataGroup']);
        this.showPreview();

      }

    })




    this.buttonCustom = [

      {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Ritorna',
        icon: "glyphicon fas fa-angle-left",
        event: 'formIndietro'


      },

      {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Salva gruppo',
        icon: "glyphicon icon-salva-form",
        event: 'formSalva'


      },
      /* {

        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        hint: 'F10 per andare avanti',
        stylingMode: 'text',
        text: 'Crea gruppo',
        icon: "glyphicon fas fa-angle-right",
        event: 'formAvanti',

      }, */



    ]

  }



  initializzed(res) {

    this.showToolBar = true;
    let textSave = ''
    if (this.SubjectCall == 'generaConfigurazione' && this.template == 'form') {

      if (res) {

        let data = JSON.parse(res);
        if (data != '') {
          let dataJS = JSON.parse(res);

          this.rowData = dataJS[0].configuration;

          let dataGroups = dataJS.filter((items, index) => !items.configuration);

          dataGroups = dataGroups.map((groups, index) => {

            groups.id = index;
            return groups;
          })

          this.rowData['dataGroups'] = dataGroups;
          this.rowData['id'] = this.id
          this.formSoggetto.SelectionRow(this.rowData)
        }


      }


      textSave = 'Salva anagrafica';
    }

    if (this.SubjectCall == 'generaGruppo') {

      let data = res;
      this.rowData = data
      let items = data.data;
      let colCount = parseInt(data.colCount)

      let generaGruppoData = data.data;
      let rigaNumero = 1;
      let counter = 0
      generaGruppoData.map((data, nC) => {

        data.indexID = nC;
        if (typeof data.colSpan == 'undefined') {
          data.colSpan = 1
        } else {
          data.colSpan = parseInt(data.colSpan)
        }
        if (data.colSpan == colCount) {

          data.rowName = 'Riga n. ' + rigaNumero;
          data.rowIndex = rigaNumero
          if (data.type == 'empty' && data.caption != '') {
            data.tipoEditor = 'Caption del gruppo';
          }

          counter = colCount

        }
        if (data.colSpan < colCount) {

          data.rowName = 'Riga n. ' + rigaNumero;
          data.rowIndex = rigaNumero
          if (data.type == 'empty' && data.caption != '') {
            data.tipoEditor = 'Caption del gruppo';
          }

          if (data.type == 'empty') {
            data.dataField = 'spazio' + nC;
          }

          counter = data.colSpan + counter


        }


        if (counter == colCount) {
          rigaNumero++
          counter = 0;
        }

        return data;


      })


      textSave = 'Salva gruppo';
    }





    this.SubjectCall == 'generaGruppo' ? false : true





  }

  showPreview() {



    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NicaFormComponent');


    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);

    setTimeout(() => {

      this.componentRef = this.previewForm.createComponent(componentFactory);


      this.componentRef.instance.nCol = 1;

      this.componentRef.instance.remoteService = true
      this.componentRef.instance.SubjectCall = this.id




    }, 300)


  }



  formEventConf(ev) {

    console.log('formEventConf', ev)

    if (ev.name == 'onEditorPrepared') {

      console.log('formEventConf onEditorPrepared-->', ev)
    }

    if (ev.name == "onEditingStart") {

      ev.data.isEdit = true;


      if (this.SubjectCall == 'generaConfigurazione') {
        this.filterID = this.formSoggetto.formEdit.formData;
        this.filterID['id'] = this.id
        //ev.data.id = this.id
        this.filterID['dataGroup'] = ev.data

        this.refreshPage(this.filterID, '', 'generaGruppo', 'form');
      } else if (this.SubjectCall == 'generaGruppo') {
        let width = ev.data.width
        if (width) {
          width = ev.data.width.toString()

          if (width.includes('px')) {

            let wwpx = width.split('px');
            ev.data.width = wwpx[0]
            ev.data.widthUm = wwpx[1]
          } else if (width.includes('vw')) {
            let wwvw = width.split('vw');
            ev.data.width = wwvw[0]
            ev.data.widthUm = wwvw[1]
          }
        }

        let eventData = this.flatten(ev.data)
        let type
        if (ev.data.dynamic) {
          type = 'campoDynamic';


        }

        if (ev.data.lista) {
          type = 'campoLista'
        }

        if (ev.data.type == 'campo') {
          type = 'campoSemplice'
        }
        if (ev.data.type == 'campoButton') {
          type = 'campoButton'
        }

        ev.eventName = type
        ev.dataSource = ev.dataSource



        this.generaItemsField(ev, eventData)
      }


    }

    if (ev.name == 'queryFilter') {

      let data = [{
        SubjectCall: 'datiKeyValue',
        ApiCall: '',
        filterKey: '',
        queryString: '',
        dataJson: {},
        type: 'simple',
        nCol: 1,
        disableEditForm: true,
        toolbarTop: false,
        toolbarBottom: true,
        heightForm: 352,
        CustomButtonSetForm: [
          {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Salva',
            icon: "glyphicon mdi mdi-content-save-outline",
            event: 'incollaDati',

          },
          {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Annulla',
            icon: "glyphicon glyphicon icon-annulla-form",
            event: 'return',

          },

        ]
      }
      ]


      const popupHeight = 430;
      const popuptitle = 'Query Filter Key';

      //this.openEditorExt(data, popuptitle, popupHeight);


    }


    if (ev == 'formAvanti') {
      switch (this.SubjectCall) {

        case 'generaConfigurazione':

          const validation = this.formSoggetto.formEdit.instance.validate();
          if (validation.isValid) {
            const formData = this.formSoggetto.formEdit.formData

            let configuration = [{
              configuration:
              {
                titleGriglia: formData.titleGriglia,
                titleForm: formData.titleForm,
                breadcrumbCaption: formData.breadcrumbCaption,
                campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
                service: formData.service,
                api: formData.api,
                filterList: formData.filterList,
                filterEditor: formData.filterEditor,
                helpDoc: formData.helpDoc,
                queryFilter: formData.queryFilter,
                idTabRif: formData.idTabRif,
                nCol: formData.nCol,
                type: formData.formType

              }
            }]

            this.refreshPage(configuration, '', 'generaGruppo', 'form');

          }

          break;
      }
    }

    if (ev.name == 'gridToolBarButtonClick') {
      this.generaItemsField(ev);
    }


    if (ev == 'formSalva') {
      const formData = this.formSoggetto.formEdit.formData;

      switch (this.SubjectCall) {
        case 'generaGruppo':
          this.saveGroup(formData)
          break;
        case 'generaConfigurazione':
          this.saveData(formData)
          break;
        default:
          break;
      }
      return;

    }
    if (ev == 'formIndietro') {
      const formData = this.formSoggetto.formEdit.formData;

      switch (this.SubjectCall) {
        case 'generaGruppo':
          this.saveGroup(formData);
          setTimeout(() => {
            this.refreshPage(this.filterID, '', 'generaConfigurazione', 'form')
          }, 400);

          break;
        case 'generaConfigurazione':
          this.filterID= []
          this.refreshPage([], '', 'generaConfigurazione', 'grid')
          break;
        default:
          break;
      }


      return;

    }
  }

  generaItemsField(ev, datas?) {
    console.log('generaItemsField', ev);


    switch (ev.eventName) {
      
      case 'campoButton':
        if (!datas) {
          datas = {
            type: 'campoButton', tipoCampo: 'campoButton',
            labelVisible: true,
            widthUm: 'px'
          }
        }
        let dataButton = [{
          SubjectCall: 'campoButton',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: datas,
          type: 'tabbed',
          nCol: 1,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 685,

          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',
              value: 'campoButton'

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',
            },

          ]
        }
        ]

        this.openEditorExt(dataButton, 'Campo con bottone', 1290, 750, ev.dataSource);
        break;
      case 'campoEmpty':
        //this.saveItem('campoEmpty')
        break;
      case 'campoSemplice':
        if (!datas) {
          datas = {
            type: 'campo', tipoCampo: 'campoSemplice',
            labelVisible: true,
            widthUm: 'px'
          }



        }
        let data = [{
          SubjectCall: 'campoSemplice',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: datas,
          type: 'tabbed',
          nCol: 1,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 685,

          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',
              value: 'campoSemplice'

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',

            },

          ]
        }
        ]


        const popupHeight = 750;
        const popupWidth = 1290;
        const popuptitle = 'Campo Semplice';
        const masterCompDataSource = ev.dataSource
        this.openEditorExt(data, popuptitle, popupWidth, popupHeight, masterCompDataSource);
        break;

      case 'campoDynamic':

        if (!datas) {
          datas = {
            type: 'campoSpecial',
            tipoCampo: 'campoDynamic',
            labelVisible: true,
            widthUm: 'px',
            dynamic_settingGrid_modeEditor:'cell'

          }
        }


        let dataDynamic = [{
          SubjectCall: 'campoDynamic',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: datas,
          type: 'tabbed',
          nCol: 2,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 730,

          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',

            },

          ]
        }
        ]


        this.openEditorExt(dataDynamic, 'Campo con popup e griglia di selezione', 1200, 800, ev.dataSource);


        break;

      case 'campoCodiceDescrizione':

        let dataCodiceDesc = [{
          SubjectCall: 'campoCodiceDesc',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: { type: 'campoSpecial', tipoCampo: 'campoCodiceDesc' },
          nCol: 2,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 522,
          type: 'tabbed',
          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',

            },

          ]
        }
        ]


        this.openEditorExt(dataCodiceDesc, 'Campo codice e relativa descrizione', 1200, 600, ev.dynamicContent);

        break;

      case 'campoLista':
        if (!datas) {
          datas = {
            type: 'campoSpecial',
            editorType: 'dxSelectBox',
            tipoCampo: 'campoLista',
            labelVisible: true,
            widthUm: 'px'
          }
        }
        let campoLista = [{
          SubjectCall: 'campoLista',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: datas,
          type: 'tabbed',
          nCol: 2,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 522,

          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',

            },

          ]
        }
        ]


        this.openEditorExt(campoLista, 'Campo lista', 1200, 600, ev.dataSource);

        break;

      case 'campoListaM':

        let campoListaM = [{
          SubjectCall: 'campoListaM',
          ApiCall: '',
          filterKey: '',
          queryString: '',
          dataJson: { type: 'campoSpecial', tipoCampo: 'campoListaM' },
          type: 'tabbed',
          nCol: 2,
          disableEditForm: true,
          toolbarTop: false,
          toolbarBottom: true,
          heightForm: 522,

          CustomButtonSetForm: [
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Salva',
              icon: "glyphicon mdi mdi-content-save-outline",
              event: 'salvaDati',

            },
            {
              location: "after",
              stylingMode: "text",
              widget: "dxButton",
              locateInMenu: "never",
              text: 'Annulla',
              icon: "glyphicon glyphicon icon-annulla-form",
              event: 'return',

            },

          ]
        }
        ]


        this.openEditorExt(campoListaM, 'Campo lista con template', 1200, 600, ev.dynamicContent);


        break;
      default:
        break;
    }
  }

  fetchDataItems(items) {
    items.forEach(itm => {


    })
  }

  saveGroup(formData) {
    
    
      let grupItem = {
        itemType: 'group',
        caption: formData.caption,
        colCount: formData.colCount,
        colSpan: formData.colSpan,
        class: formData.class,
        groupDataField: formData.groupDataField ? formData.groupDataField : formData.caption.replace(' ', '-'),
        disabled: typeof formData.disabled != 'undefined' ? formData.disabled : false,
        visible: formData.visible,
        data: formData.data
      }

      //console.log('formSalva grupItem', grupItem);
      //console.log('datas', this.datas);
      let data = []
      
      /* if(this.filterID['dataGroups']){
        data = this.filterID['dataGroups'];
      } */
       
      let newData = data.concat(grupItem);





      this.filterID['dataGroups'] = grupItem;

      this.filterID['id'] = this.id


      //this.refreshPage(this.filterID, '', this.SubjectCall, 'form');

    



    this.saveData(this.filterID)

  }

  onShowing(e) {
    //////console.log('eventooooo',e);

    //this.showEdit = true;
    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content

    //<div class="dx-item-content dx-box-item-content" style="width: auto; height: auto; display: flex; flex-basis: 0px; flex-grow: 1; flex-direction: column;"></div>
    //soggetto-form
    setTimeout(() => {
      var tt = $(".soggetto-form").find(".dx-item .dx-box-item");
      //var tt=$(".dx-item-content .dx-box-item-content");
      //tt[tt.length-1].remove();
      //console.log("ecco le classi ",tt);

    }, 200);

    //$( ".hello" ).remove();
    /*
    if(this.formEditingPopup !== undefined)
      this.formEditingPopup.visible=true;
    */
  }

  openEditorExt(dataToSend, title, popupWidth, popupHeight, masterCompDataSource) {

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NicaFormComponent');

    this._overlaySidePanelService.setTitle(title);

    this._overlaySidePanelService.setContent(factoryClass);
    this._overlaySidePanelService.sendDataToComponent(dataToSend);
    this._overlaySidePanelService.sendClassToComponent('form-generate')

    this._overlaySideFormService.setPopupWidth(popupWidth);
    this._overlaySideFormService.setPopupHeight(popupHeight);
    this._overlaySidePanelService.show();

    setTimeout(() => {


      (this._overlaySideFormService._hrefComponent.instance.emittendButtonPush as EventEmitter<any>).subscribe(

        (res) => {
          if (res.name == 'onValueChanged') {

            /* if(res.campo.dataField == 'dynamic_settingGrid_colonneD'){
              
              confirm('Inserendo le colonne il campo service verrà cancellato Procedi?','Attenzione!').then(resY=>{
                if(resY){
                  res.masterComponent.updateData('dynamic_service','')
                }
              })
            } */


          }
          if (res == 'salvaDati') {

            const form = this._overlaySideFormService._hrefComponent.instance.formEdit.instance;
            const formData = this._overlaySideFormService._hrefComponent.instance.formEdit.formData;
            const SubjectCall = dataToSend[0].SubjectCall
            this.saveItem(SubjectCall, form, formData, masterCompDataSource)

          }


          if (res == 'return') {
            this._overlaySideFormService.close();

            return;

          }


        }
      )
    }, 600)
  }

  saveData(formData) {
    if (formData.id) {


      let data = [{
        configuration:
        {
          titleGriglia: formData.titleGriglia,
          titleForm: formData.titleForm,
          breadcrumbCaption: formData.breadcrumbCaption,
          campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
          service: formData.service,
          api: formData.api,
          filterList: formData.filterList,
          filterEditor: formData.filterEditor,
          helpDoc: formData.helpDoc,
          queryFilter: formData.queryFilter,
          idTabRif: formData.idTabRif,
          nCol: formData.nCol,
          type: formData.formType

        }
      }]

      data = data.concat(formData['dataGroups'])

      let dataToSend = {
        id: this.id,
        json: JSON.stringify(data)
      }

      this.anagraficaService.actionPut(this.apiset, dataToSend).then(re => {
        this.refreshPage(re, '', this.SubjectCall, this.template)
      })


    }else{
      let data = [{
        configuration:
        {
          titleGriglia: formData.titleGriglia,
          titleForm: formData.titleForm,
          breadcrumbCaption: formData.breadcrumbCaption,
          campoTitle: ['descrizioneSoggetto', 'descrizioneSede'],
          service: formData.service,
          api: formData.api,
          filterList: formData.filterList,
          filterEditor: formData.filterEditor,
          helpDoc: formData.helpDoc,
          queryFilter: formData.queryFilter,
          idTabRif: formData.idTabRif,
          nCol: formData.nCol,
          type: formData.formType

        }
      }]
      let dataToSend = {
        nomeModello:formData.titleForm,
        json: JSON.stringify(data)
      }
      this.anagraficaService.actionInsert(this.apiset, dataToSend).then(re => {
        this.refreshPage(re, '', this.SubjectCall, this.template)
      })

    }
  }

  saveItem(sub, form, formData, masterCompDataSource) {
    console.log(form)
    console.log(formData);

    //console.log(grid.getSelectedRowKeys());




    switch (sub) {

      case 'campoEmpty':

        let cdindexE = masterCompDataSource.findIndex(dat => dat.dataField == formData.dataField);

        let campoEmpty = {
          type: 'empty',
          caption: '',
          colSpan: '',

        }

        if (cdindexE >= 0) {
          masterCompDataSource[cdindexE] = campoEmpty;
        } else {
          masterCompDataSource.push(campoEmpty);
        }
        this.formSoggetto.formRefreshInputData('data', masterCompDataSource);

        break;

      case 'campoSemplice':
        const valid = form.validate()
        const datas = formData
        if (valid.isValid) {


          //let dataSelect = grid.dynamicGridComponent.instance.getSelectedRowKeys();

          let cindex = masterCompDataSource.findIndex(dat => dat.dataField == formData.dataField);

          const cSimple = this.createSimpleItems(formData)


          for (const value in cSimple) {
            if (typeof cSimple[value] == 'undefined') {
              delete cSimple[value]
            }

            if (typeof cSimple[value] == 'object') {
              for (const val in cSimple[value]) {

                if (typeof cSimple[value][val] == 'undefined') {
                  delete cSimple[value][val]
                }
              }
            }
          }


          if (cindex >= 0) {
            masterCompDataSource[cindex] = cSimple
          } else {
            masterCompDataSource.push(cSimple)
          }
          this.formSoggetto.formRefreshInputData('data', masterCompDataSource);
          /*  grid.dynamicGridComponent.instance.refresh();
           grid.dynamicGridComponent.instance.repaint(); */
          this._overlaySideFormService.close();

        }

        // this.formSoggetto.formEdit.instance.updateData('dataElementField', ff);

        break;
      case 'campoDynamic':
        const validCampoDynamic = form.validate()

        if (validCampoDynamic.isValid) {
          let ff = [];
          let cdindex = masterCompDataSource.findIndex(dat => dat.dataField == formData.dataField);


          if (formData.dynamic_valueExpr != '' && formData.dynamic_displayExpr != '') {
            let newFormData = formData;
            newFormData.class = 'd-none';
            newFormData.labelVisible = false;
            const cSimple1 = this.createSimpleItems(newFormData)
            const Dynamic1 = this.createDynamicItemsSimple(formData)

            const cDynamic1 = { ...cSimple1, ...Dynamic1 };

            for (const value in cDynamic1) {
              if (typeof cDynamic1[value] == 'undefined') {
                delete cDynamic1[value]
              }

              if (typeof cDynamic1[value] == 'object') {
                for (const val in cDynamic1[value]) {

                  if (typeof cDynamic1[value][val] == 'undefined') {
                    delete cDynamic1[value][val]
                  }
                }
              }
            }
            if (cdindex <= 0) {
              masterCompDataSource.push(cDynamic1)
            }
            formData.dynamic_related_5 = formData.dynamic_valueExpr + '|' + formData.dataField
            formData.dynamic_valueExpr = '';
            formData.class = ''
            formData.class = ''
          }

          const cSimple = this.createSimpleItems(formData)
          const Dynamic = this.createDynamicItems(formData)


          const cDynamic = { ...cSimple, ...Dynamic };



          for (const value in cDynamic) {
            if (typeof cDynamic[value] == 'undefined') {
              delete cDynamic[value]
            }

            if (typeof cDynamic[value] == 'object') {
              for (const val in cDynamic[value]) {

                if (typeof cDynamic[value][val] == 'undefined') {
                  delete cDynamic[value][val]
                }
              }
            }
          }

          if (cdindex > 0) {
            masterCompDataSource[cdindex] = cDynamic
          } else {
            masterCompDataSource.push(cDynamic)
          }

          this.formSoggetto.formEdit.instance.updateData('data', masterCompDataSource);
          console.log('formData', this.filterID)

          this._overlaySideFormService.close();


        }

        break;
      case 'campoButton':

        let cbindex = masterCompDataSource.findIndex(dat => dat.dataField == formData.dataField);


        const cSimpleB = this.createSimpleItems(formData)
        const Button = this.createButtonItems(formData)


        const cButton = { ...cSimpleB, ...Button };

        for (const value in cButton) {
          if (typeof cButton[value] == 'undefined') {
            delete cButton[value]
          }

          if (typeof cButton[value] == 'object') {
            for (const val in cButton[value]) {

              if (typeof cButton[value][val] == 'undefined') {
                delete cButton[value][val]
              }
            }
          }
        }

        if (cbindex > 0) {
          masterCompDataSource[cbindex] = cButton
        } else {
          masterCompDataSource.push(cButton)
        }

        this.formSoggetto.formEdit.instance.updateData('data', masterCompDataSource);
        console.log('formData', this.filterID)

        this._overlaySideFormService.close();

        break;
      case 'campoCodiceDesc':
        const validCCodiceDescrizione = form.validate()

        if (validCCodiceDescrizione.isValid) {
          let ff = masterCompDataSource;


          //Codice

          let cDynamicCodice = {
            type: formData.type,
            dataField: formData.dataField,
            dataType: formData.dataType,
            caption: formData.caption,
            width: formData.width + formData.widthUm,
            orderGriglia: formData.orderGriglia,
            maxLength: formData.maxLength,
            colVisible: formData.colVisible,
            colWidth: formData.colWidth,
            colSpan: formData.colSpan,
            labelVisible: formData.labelVisible,
            labelPosition: formData.labelVisible,
            labelAlignment: formData.labelAlignment,
            showColon: formData.showColon,
            disableOnUpdate: formData.disableOnUpdate,
            disabled: formData.disableOnUpdate,
            hideOnEdit: formData.hideOnEdit,
            editorClass: formData.editorClass,

            /* validation: [
              { type: 'required', message: 'Campo obbligatorio' }
            ], */
            dynamic: {

              dataSource: formData.dataSource,
              service: formData.service,
              autocomplete: false,
              valueExpr: formData.valueExpr,
              displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 
              queryString: formData.queryString,
              filterStatic: formData.filterStatic,
              related: ["'" + formData.valueExpr + "'|" + formData.dataField + 'Desc' + "'"],


            }
          }

          ff.push(cDynamicCodice)

          //Descrizione


          let cDynamicDescrizione = {
            type: formData.type,
            dataField: formData.dataField,
            dataType: formData.dataType,
            caption: formData.caption,
            width: formData.width + formData.widthUm,
            orderGriglia: formData.orderGriglia,
            maxLength: formData.maxLength,
            colVisible: formData.colVisible,
            colWidth: formData.colWidth,
            colSpan: formData.colSpan,
            labelVisible: formData.labelVisible,
            labelPosition: formData.labelVisible,
            labelAlignment: formData.labelAlignment,
            showColon: formData.showColon,
            editorType: formData.editorType,
            disableOnUpdate: formData.disableOnUpdate,
            disabled: formData.disableOnUpdate,
            hideOnEdit: formData.hideOnEdit,
            helpText: formData.helpText,
            editorClass: formData.editorClass,
            attr: formData.attr,
            mask: formData.mask,
            /* validation: [
              { type: 'required', message: 'Campo obbligatorio' }
            ], */
            dynamic: {
              searchExpr: '', //Utilizzare un secondo campo per effettuare una ricerca in or  
              dataSource: formData.dataSource,
              service: formData.service,
              autocomplete: formData.autocomplete,
              checkValue: {
                checkValueMessage: formData.checkValueMessage,
                forceInsert: formData.forceInsert //Se true forza il cammpo anche se non trovato nella ricerca ODATA
              },
              valueExpr: '',
              displayExpr: formData.displayExpr, //Possibile inserire anche un array di campi da far apparire a video separati da - 
              caption: formData.captionD,
              queryString: formData.queryString,
              filterStatic: formData.filterStatic,
              componentType: 'grid',
              related: null,
              enableEditor: {
                add: formData.add,
                remove: formData.remove,
                update: formData.update
              },
              buttonOption: {
                text: formData.dataField,
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: formData.caption,
                name: formData.dataField,
                location: 'after',
              }
            }
          }

          ff.push(cDynamicDescrizione);

          this.formSoggetto.formEdit.instance.updateData('data', ff);

          this._overlaySideFormService.close();
        }

        break;
      case 'campoLista':

        const validCampoLista = form.validate()

        if (validCampoLista.isValid) {


          let ff = [];
          let cLIndex = masterCompDataSource.findIndex(dat => dat.dataField == formData.dataField);

          const cSimple = this.createSimpleItems(formData)
          const Lista = this.createListaItems(formData)


          const cLista = { ...cSimple, ...Lista };

          for (const value in cLista) {
            if (typeof cLista[value] == 'undefined') {
              delete cLista[value]
            }

            if (typeof cLista[value] == 'object') {
              for (const val in cLista[value]) {

                if (typeof cLista[value][val] == 'undefined') {
                  delete cLista[value][val]
                }
              }
            }
          }




          if (cLIndex > 0) {
            masterCompDataSource[cLIndex] = cLista
          } else {
            masterCompDataSource.push(cLista)
          }


          this.formSoggetto.formEdit.instance.updateData('data', masterCompDataSource);
          console.log('validCampoDynamic', masterCompDataSource)


          this._overlaySideFormService.close();

        }

        break;
      case 'campoListaM':
        const campoListaM = form.validate()

        if (campoListaM.isValid) {
          let ff = masterCompDataSource;

          let cListaM = {
            type: formData.type,
            dataField: formData.dataField + 'Desc',
            dataType: formData.dataType,
            caption: formData.caption,
            width: formData.width + formData.widthUm,
            orderGriglia: formData.orderGriglia,
            maxLength: formData.maxLength,
            colVisible: formData.colVisible,
            colWidth: formData.colWidth,
            colSpan: formData.colSpan,
            labelVisible: formData.labelVisible,
            labelPosition: formData.labelVisible,
            labelAlignment: formData.labelAlignment,
            showColon: formData.showColon,
            editorType: formData.editorType,
            disableOnUpdate: formData.disableOnUpdate,
            disabled: formData.disableOnUpdate,
            hideOnEdit: formData.hideOnEdit,
            helpText: formData.helpText,
            editorClass: formData.editorClass,
            attr: formData.attr,
            mask: formData.mask,
            dynamic: {
              dataSource: formData.dataSource,
              autocomplete: false,
              valueExpr: '',
              displayExpr: formData.displayExpr,
              caption: formData.captionD,
              queryString: formData.queryString,
              filterStatic: formData.filterStatic,
              componentType: 'dynamicGrid',
              related: [formData.dataField],
              buttonOption: {
                text: formData.caption,
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: formData.caption,
                name: formData.dataField,
                location: 'after',
                event: formData.inLine //POPUP di tipo OVER che appare sotto all'input
              },
              settingGrid: {
                campoTabRif: formData.campoTabRif,// in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio,
                masterKey: formData.masterKey,
                keyUnique: formData.keyUnique,
                selectionMode: formData.selectionMode,
                mode: formData.mode,
                rowAlternationEnabled: true,
                repaintChangesOnly: false,
                remoteOperations: true,
                hoverStateEnabled: true,
                allowUpdating: formData.allowUpdating,
                allowDeleting: formData.allowDeleting,
                allowAdding: formData.allowAdding,
                searchAndSelect: false,
                /* searchAndSelectDataSource: '',
                colonne: [
                {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                width: 70,
                hideOnEdit: true
                },
                {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Operazione di smaltimento',
                hideOnEdit: false
                }, 
                ]*/
              }
            }
          }

          ff.push(cListaM);

          this.formSoggetto.formEdit.instance.updateData('data', ff);


          this._overlaySideFormService.close();
        }

        break;

      default:
        break;
    }


    this.saveGroup(this.formSoggetto.formEdit.formData)
  }

  repaintRows(data, colCount) {
    let counter
    data.map(daa => {


      if (data.colSpan == colCount) {



        counter = 0;
        return data;
      } else {
        counter++;

      }
      if (counter == colCount) {
        counter = 0;

      }


      return data;
    })
  }

  flatten(obj) {
    var flattenedObject = {};
    this.traverseAndFlatten(obj, flattenedObject);
    return flattenedObject;
  }
  traverseAndFlatten(currentNode, target, flattenedKey?) {
    for (var key in currentNode) {
      if (currentNode.hasOwnProperty(key)) {
        var newKey;


        if (flattenedKey === undefined) {
          newKey = key;
        } else {
          newKey = flattenedKey + '_' + key;
        }

        var value = currentNode[key];
        if (typeof value === "object") {
          this.traverseAndFlatten(value, target, newKey);
        } else {
          target[newKey] = value;

        }
      }
    }


  }

  createSimpleItems(formData) {
    let width = '100%'
    
    if(formData.width){
      width = formData.width
    }
   

   
    if (width.includes('px') || width.includes('vw')) {
      width = width.replace('px', '')
      width = width.replace('vw', '')
    }

    if (typeof formData.widthUm != 'undefined') {
      width = width + formData.widthUm
    } else {
      width = width + 'px'
    }

    return {
      type: formData.type,
      dataField: formData.dataField,
      dataType: formData.dataType,
      caption: formData.caption,
      width: width,
      orderGriglia: formData.orderGriglia,
      maxLength: formData.maxLength,
      colVisible: formData.colVisible,
      colWidth: formData.colWidth,
      colSpan: formData.colSpan,
      class: formData.class,
      labelVisible: typeof formData.labelVisible != 'undefined' ? formData.labelVisible : true,
      labelPosition: typeof formData.labelPosition != 'undefined' ? formData.labelPosition : 'left',
      labelAlignment: typeof formData.labelAlignment != 'undefined' ? formData.labelAlignment : 'right',
      showColon: formData.showColon,
      editorType: formData.editorType,
      disableOnUpdate: formData.disableOnUpdate,
      /* disabled: formData.disabled, */
      hideOnEdit: typeof formData.hideOnEdit != 'undefined' ? formData.hideOnEdit : false,
      helpText: formData.helpText,
      editorClass: formData.editorClass,
      attr: formData.attr,
      mask: formData.mask,


    }
  }

  createDynamicItems(formData) {




    let related = []

    if (formData.dynamic_related_0) {
      related.push(formData.dynamic_related_0);
    }
    if (formData.dynamic_related_1) {
      related.push(formData.dynamic_related_1);
    }
    if (formData.dynamic_related_2) {
      related.push(formData.dynamic_related_2);
    }
    if (formData.dynamic_related_3) {
      related.push(formData.dynamic_related_3);
    }
    if (formData.dynamic_related_4) {
      related.push(formData.dynamic_related_4);
    }
    if (typeof formData.dynamic_related_5 != 'undefined') {
      related.push(formData.dynamic_related_5);
    }

    let colonne = null
    if (formData.dynamic_settingGrid_colonne) {
      colonne = formData.dynamic_settingGrid_colonne
    }



    return {
      dynamic: {
        searchExpr: '', //Utilizzare un secondo campo per effettuare una ricerca in or  
        dataSource: formData.dynamic_dataSource,
        service: formData.dynamic_service,
        autocomplete: false,//formData.autocomplete,
        checkValue: {
          checkValueMessage: formData.dynamic_checkValue_checkValueMessage,
          forceInsert: formData.dynamic_checkValue_forceInsert //Se true forza il cammpo anche se non trovato nella ricerca ODATA
        },
        valueExpr: formData.dynamic_valueExpr,
        displayExpr: formData.dynamic_displayExpr, //Possibile inserire anche un array di campi da far apparire a video separati da - 
        caption: formData.dynamic_caption,
        queryString: formData.dynamic_queryString,
        filterStatic: formData.dynamic_filterStatic,
        componentType: formData.dynamic_componentType,
        related: related,

        buttonOption: {
          text: formData.dataField,
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: formData.caption,
          name: formData.dataField,
          location: 'after',
        },
        settingGrid: {
          campoTabRif: formData.dynamic_settingGrid_campoTabRif,
          masterKey: formData.dynamic_settingGrid_masterKey,
          keyUnique: formData.dynamic_settingGrid_keyUnique,
          mode: formData.dynamic_settingGrid_modeEditor,
          selectionMode: formData.dynamic_settingGrid_selectionMode,
          rowAlternationEnabled: true,
          repaintChangesOnly: false,
          remoteOperations: true,
          hoverStateEnabled: true,
          allowUpdating: formData.dynamic_settingGrid_allowUpdating,
          allowDeleting: formData.dynamic_settingGrid_allowDeleting,
          allowAdding: formData.dynamic_settingGrid_allowAdding,
          searchAndSelect: false, //Cerca Valore e seleziona
          height: 700,
          showColBlank: formData.dynamic_settingGrid_showColBlank,
          showFilterSearch: formData.dynamic_settingGrid_showFilterSearch,

          colonne: colonne

        }
      }
    }
  }
  createDynamicItemsSimple(formData) {

    formData.dynamic_related_1,
      formData.dynamic_related_2
    formData.dynamic_related_3
    formData.dynamic_related_4


    let related = [formData.dynamic_displayExpr + '|' + formData.dataField + formData.dynamic_displayExpr]





    return {
      dynamic: {

        dataSource: formData.dynamic_dataSource,
        service: formData.dynamic_service,
        autocomplete: false,//formData.autocomplete,

        valueExpr: formData.dynamic_valueExpr,
        displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 

        related: related,


      }
    }
  }

  createListaItems(formData) {
    return {
      lista: {

        valueExpr: formData.lista_valueExpr,
        queryString: formData.lisata_queryString,//ODATA FILTER
        displayExpr: formData.lista_displayExpr,
        dataSource: formData.lista_dataSource,
        static: formData.lista_static,
        items: formData.lista_dataSource == '' || formData.lista_dataSource == null ? formData.lista_items : null,
        cascading: formData.cascading,
        related: formData.lista_related,
        showDropDownButton: formData.lista_showDropDownButton,
        placeholder: formData.lista_placeholder

      }
    }
  }
  createButtonItems(formData) {
    formData.dynamic_related_1,
      formData.dynamic_related_2
    formData.dynamic_related_3
    formData.dynamic_related_4


    let related = [formData.button_related_0, formData.button_related_1]

    return {
      button: {
        text: formData.button_text,
        name: formData.button_name,
        location: formData.button_location,
        event: formData.button_event,
        hint: formData.button_hint,
        icon: formData.button_icon,
        outPutValue: formData.button_outPutValue,
        related: related
      }
    }
  }
}
/*
  this.configuration = [
      {
        titolo: "Configurazione dell'anagrafica",
        testo: `configuration:{
          title: 'Registri Carico Scarico', //Titolo dell'anagrafica 
          masterKey: 'id',                  //La chiave univoca dalle API 
          service: 'RegistroRifiuti',       //Nome del servizio da richiamare per costruire la form e la tabella
          api: 'RegistroRifiuti',           //Nome dell'API per le operazioni di GET/EDIT/INSERT
          filterList: '/$',                 //FIltro (path) nell'API interessata per ottenere la lista dei RECORD da visualizzare
          filterEditor: '?id=$',            //FIltro (path) nell'API interessata per le operazioni di EDIT/INSERT/DELETE
          formType: 'simple',               //Tipo di viusualizzazione della FORM, a TAB (tabbed) o TAB a step(tabbedstep) o Semplice(simple) 
          idTabRif: [                       //Gli id/chiavi di riferimento nella tabella DB 
            {key: "idSede",value: 'idSede'} //-->In questo caso l'id di riferimento è la sede idSede 
          ],
          queryFilter:[                     //-->Definisce i paramentri per unca chimata con querystring path
            { 
              key:'NostreAziende',
              value:'nsAzienda'
            }
          ],
          componentGrid:'dynamicGrid'       //Se specificato verrà inizializzato un componente diverso da NicaAnagrafica griglia
          colCount:'2'                      //Se definito, i gruppi (itemType=group) saranno affiancati per il numero di colonne definito da quest'ultimo
        }`
      },
      {

        titolo: 'ItemType Group come usarlo ',
        testo: `{
          itemType: "group",                      //Tipo group, raggruppa gli items nella form itemType:buttonMenu sono i bottoni nell'anagrafica e nalla griglia
          groupDataField: 'produttore',           //Se definito nella form tipo tabStep, darà un nome all tab per la validazione del gruppo
          disabled: false,                        //Abilita o disabilita il gruppo
          caption: "Produttore o Dententore",     //Il nome del gruppo 
          colCount: "4",                          //Fodamentale! è il numero di items che si affiancheranno in una riga
          colSpan:"2"                             //Se definito il numero di colonne nella form e definito il colSpan del gruppo, il gruppo prenderà la spaziatura definita es. colCoun(Form)=2, colSpan(del gruppo)=2, il gruppo prenderà lo spazio di due colonne      
          data: []                                //definizione degli items della form e le colonne della griglia
        }`
      },
      {
        titolo: "Bottoni Griglia e Menu SX dell'annagrafica",
        testo: `{
      itemType: "buttonMenu",   //Tipo bottone, farà visualizzare il menu laterale nella Form e i bottoni nella  griglia 
      data: [
        {
          type: 'menuToolbar',  //Identifica la colonna dove verranno mostrati i bottoni
          orderGriglia: 1,      //per nicaAnagrafica
          colVisible: true,     //true o false, obbligatorio True per mostrare i bottoni nella griglia
         
          buttons: [
            //Tipo Bottone Navigazione
            { 
              name: 'Autor. Aree',              //Nome e label del bottone
              icon: 'glyphicon icon-cer-area',  //Icona del bottone, è importante inserire glyphicon per i componenti devExtreme, 
              dataSource: 'autorizzazionearea', //Nome del servizio da richiamare per costruire la form o la tabella
              hint: 'Autorizzazioni Area',      //Fa comparire una brave descrizione al focus del mouse
              event: '3',                       //Evento tipo tre serve per navigare tra le schermate griglia e form
              location: 'top',                  //Top o bottom, la posizione del bottone nel menu della form
              displayMode: 'in-line'            //Se in-line il nome(la label) verrà affiancata all'icona 
            },
           
            //Tipo Bottone PopUp
            
            { 
              name: 'Documenti',
              icon: 'glyphicon icon-documenti-form',
              value: 'NicaFileManagerComponent',      //Il nome del componente Angualr che verrà aperto in popUp
              costantValue: 'soggetti',               //Il valore costante di tipo stringa che in genere è usato come filtro nelle API es. nomeTabella=soggetti
              
              event: '1',                             //Evento tipo uno serve per aprire il componente in popUp 
              wPopUp: "1000",                         //Larghezza del popUp 
              hPopUp: "527"                           //Altezza del popUp 
              location: 'top'         
            },

          ]
        }
      ]
    }`},
      {
        titolo: 'Tipo Empty e Caption desc',
        testo: `
  
      { 
        type: 'empty',                          //Tipo empty, aggiunge un campo vuoto se necessario nella FORM
        colVisible: false,                      //Se settato a false il campo non compare nella griglia 
        caption: "Attività svolta..",           //Se definita una caption il campo empty sarà una testo, se definito il colSpan il campo sarà un separatore tipo, vedi la form delle sedi
        colSpan: '4'                            //vedi definizione di colSpan
      }
      `
      },
      {
        titolo: 'Tipo Campo semplice',
        testo: `
      {
        type: 'campo',                          //Tipo campo,un campo semplice definito dall'editorType
        dataField: "descrizione",               //dataField, nome del campo definito nelle API 
        class: "form-control",                  //classe CSS
        caption: "Descrizione",                 //Definisce la label
        colVisible: true,                       //Se settato su false il campo non verrà visualizzato nella griglia
        colSpan: "4",                           //colSpan, è la spaziatura che il campo occuperà nella riga, deve essere dello stesso valore di 
  
        maxSize: 45,                            //La larghezza del campo input
        maxLength: "45",                        //Il massimo di caratteri che un campo può contenere
        width: 45 // aspect,                     //La larghezza dell'item nella form. L'aspect è una varibile che definisce la proporzione relativa al font usato
        validation: [                           //Serve per la validazione dei campi far rif. alla guida di devExtreme
          { type: "required", message: "Campo Obbligatorio" },
  
        ],
      },
     
      `
      },
      {
        titolo: 'Lista Select semplice',
        testo: `
      {
        type: 'campoSpecial',                   //Tipo campoSpecial, tutti i campi che devono avere dei comportamenti specifici sono definiti comecampoSpecial
        colVisible: false,                  
        dataField: 'um',                          
        dataType: "",           
        hideOnEdit: false,  
        caption: 'Unità misura',
        editorType: 'dxSelectBox',             //In genere i campiSpecil sono i componenti di devExtreme dell'editor per ora abbiamo utlizzato dxSelectBox, dxLookup,      
        lista: {                               //Definisce la tiologia di campoSpecial, in questo caso è una lista 
          dataSource: 'um',                    //Definisce il datasource se la lista è statica nonn richiama un API, effettua un chimata ad un service interno all'applicazione(form-template-service), viceversa se definita richiama un API per ottenere una oggetto di dati 
          valueExpr: 'id',                     //E' il valore del campo selezionato nella lista  
          displayExpr: 'descrizione',          //E' il valore che verrà visualizzato a video  
          static: true                         //Se true la lista è statica non richiama un API, effettua un chimata ad un service interno all'applicazione(form-template-service)  
          filterPath: 'idSede',                //Eventuale campo es. id per effettuare la chiamata API, esempio ottenere i magazzini della sede 1  
          filter: '?nomeTabella=Sedi',         //Filtro statico(query string) per effettuare la chiamata API con una querystring conosciuta e statica
        },
        validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
      }`
      },
      {
        titolo: 'Lista Tipo LookUp',
        testo: `
      {
        type: 'campoSpecial', 
        dataField: "cer", 
        caption: "Codice ERR",
        colVisible: true,
        lookup: {                                   //Definisce la tiologia di campoSpecial, in questo caso è una LookUp, ha le stesse caratteristiche della Lista solo che possibile definire delle colonne per far apparire una griglia al suo interno in NicaAnagrafica
          dataSource: 'cer',
          valueExpr: 'id',
          displayExpr: 'id',
          caption: 'EER',
          related: ['descrizione|cerDescrizione'],  //Relaziona un campo prensente nel lookUp con un altro campo presente della Form o nella griglia
          colonne: [                                //In nica Anagrafica definendo le colonne sarà possibile far visualizzare una griglia all'interno della select tipo lookup
            {
              dataField: 'id',
              dataType: '',
              caption: 'Codice ERR'
  
            },
            {
              dataField: 'descrizione',
              dataType: '',
              caption: 'Descrizione'
  
            }
          ]
  
        }
      },`
      },
      {
        titolo: 'Lista Multiselect nella Form',
        testo: `
      {
        type: 'campoSpecial', 
        dataField: "listaModStoccaggioDesc", 
        dataType: "", 
        caption: "Modalità di stoccaggio", 
        width: 39 // aspect,
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: true,
        dynamic: {                                //Tutti i campi che devono richiamare una griglia o una lista hanno la caratteristiche dynamic
  
          dataSource: 'OperazioneSmaltimento',
          valueExpr: 'id',
          displayExpr: 'Descrizione',
          caption: "Lista Opezioni Smaltimento",  //E' la discrizione che appare sopra al popUp o popOver quando viene richimato il componete dynamic  
          queryString: '',                        //Query string statica es nomeTabella=sedi
          filter: '/',                            //Campo Filtro per la chiamata API, definito con / indica che non è presente un campo filtro 
          componentType: 'dynamicGrid',           //Indica se visualizzare il componente dynamicGrid o DynamicList, utilizzare grid per far visualizzare nicaAnagrafica 
          related: ['listaModStoccaggio'],        //indica i campi da relazionare dopo la selezione del campo nella griglia o lista
          
          buttonOption: {                         //Definisce il bottone che verrà visualizzato all'interno dell'item per far comparire la griglia o la lista
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',
            event: 'inLine'                       //In Line fa apparire la griglia sotto all'item nella form
          },
          settingGrid: {
            campoTabRif: '',                     //se la griglia è abilitata ad effettuare inserimento o modifica del campo, indicare un eventuale campo associato per le chimate API       
            masterKey: 'id',
            keyUnique: 'id',              
            selectionMode: 'multiple',          //single per la selezione unica, multiple nel caso in cuoi vengano selezionati più campi. Nel caso in cuoi sia selezionata la modalità multipla, verrà ritornato un oggetto contente tutti i dati delle righe selezionate
            rowAlternationEnabled: true,        //opzioni della griglia, vedi doc devExtreme
            repaintChangesOnly: false,
            remoteOperations: false,
            hoverStateEnabled: true,
            allowUpdating: false,               //abilita e disabilita edit nella griglia
            allowDeleting: false,               //abilita e disabilita delete nella griglia
            allowAdding: false,                 //abilita e disabilita inserimento nella griglia
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
  
                hideOnEdit: true
              },
  
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Categoria',
  
                hideOnEdit: false
              },
  
  
            ]
  
          }
  
        }
      }`
      },
      {

        titolo: 'Lista con selezione record singolo in PopUp nella Form (Usando NicaAnagrafica)',
        testo:
          `{
          type: 'campoSpecial', 
          dataField: "zonaDesc", 
          dataType: "", 
          caption: "", 
          width: 37 // aspect,
          colVisible: false,
          labelVisible: false,
          costantValue: [{ key: 'nomeTabella', value: 'sedi' }], //Valore costate  statico per le API per nica Anagrafica
          
          dynamic: {
            dataSource: 'zona',
            autocomplete: false,                                  //Se true effutta la ricerca in lavorazione con Igniazio
            checkValue: {
              checkValueMessage: '',                              //In lavorazione
              forceInsert: false                                  //In lavorazione forza l'inserimento se valore non esiste nel DB
            },
            valueExpr: '',
            displayExpr: 'descrizione',
            caption: "Lista Categorie",
            queryString: '?nomeTabella=sedi',                     ////Valore costate  statico per le API per nica Anagrafica
            componentType: 'grid',                                //Definisce se aprire il componente nicaAnagrafica
            related: ['id|idZona'],                               //Se presente Pipe il splitta il campo in un array prende il valore sulla sx e lo inserisce nel campo relazionato a dx del pipe  
            enableEditor: true,                                   //
            buttonOption: {
              text: 'Zone',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Zone',
              name: 'Zone',
              location: 'after',
              event:'popUp'                                       //Apre il campo in popUp
            }
    
          }
        }
      `
      },
      {
        titolo: 'Tipo TagBox nella Form',
        testo: `
      {
        type: 'campoSpecial', 
        dataField: "listaModStoccaggio", 
        colVisible: true, dataType: "", 
        caption: "Modalità stoccaggio", 
        hideOnEdit: false,
        width: 36 // aspect,
        maxLength: '45',
  
        tagBoxList: {
          dataSource: 'OperazioneSmaltimento',
          displayExpr: 'id',
          valueExpr: 'id',
          maxDisplayedTags?: number;
        },
        editorType:'dxTagBoxList'
      }`
      }


    ]



*/